import { contentRequestBaseOps } from '@basehub/data/replicache/index'
import { WriteTransaction } from 'replicache'

const resolveConflict = async (
  tx: WriteTransaction,
  {
    contentRequestId,
    resolution,
    richTextNodeIndex,
    sourceBlockId,
    type,
  }: {
    contentRequestId: string
    sourceBlockId: string
    richTextNodeIndex?: number
    resolution: 'source' | 'base' | null
    type: 'block' | 'br'
  }
) => {
  const contentRequest = await contentRequestMutators.getContentRequest(
    tx,
    contentRequestId
  )
  if (!contentRequest) throw new Error('Content request not found')

  const updatedConflictResolutions = {
    ...(contentRequest.conflictResolutions ?? {}),
  }

  const key = `${type === 'block' ? '' : 'br/'}${sourceBlockId}${
    typeof richTextNodeIndex === 'number' ? `/${richTextNodeIndex}` : ''
  }`

  if (resolution === null) {
    delete updatedConflictResolutions[key]
  } else {
    updatedConflictResolutions[key] = resolution
  }

  await contentRequestBaseOps.update(tx, {
    id: contentRequest.id,
    conflictResolutions: updatedConflictResolutions,
  })
}

export const contentRequestMutators = {
  getContentRequest: contentRequestBaseOps.get,
  listContentRequests: contentRequestBaseOps.list,
  createContentRequest: contentRequestBaseOps.set,
  updateContentRequest: contentRequestBaseOps.update,
  resolveConflict,
}
